import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../utilities/ApiConfig";
import formatDate from "../utilities/formatDate";
import editmodificationimg from "../assets/images/editmodificationimg.png";
import { faO } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const ModifyReceiptTable = ({ data }) => {
  const [openPopup, setOpenPopup] = useState(false);
  const { userDetails } = useSelector((state) => state.auth);
  console.log("user login data", userDetails);

  console.log(data);

  const navigate = useNavigate();

  const handleNavigateUpdatePages = (typeRecpt, regYear, vol, sr) => {
    debugger;
    let targetPage = "";

    if (typeRecpt.toLowerCase() === "search") {
      targetPage = "/SearchReceipt";
    } else if (typeRecpt.toLowerCase() === "copy") {
      targetPage = "/CopyReceipt";
    } else if (typeRecpt.toLowerCase() === "inspection") {
      targetPage = "/InspectionReceipt";
    } else if (typeRecpt.toLowerCase() === "commission") {
      targetPage = "/Commision";
    } else if (typeRecpt.toLowerCase() === "defeceit") {
      targetPage = "/DeficiateReceipt";
    } else if (typeRecpt.toLowerCase() === "others") {
      targetPage = "/Other";
    } else if (typeRecpt.toLowerCase() === "miscelleneous") {
      targetPage = "/NewReceipt";
    } else {
      toast.error("Invalid receipt type");
      return;
    }

    navigate(targetPage, {
      state: { regYear, vol, sr, typeRecpt, mod: true },
    });
  };

  const handleGetVoucherData = async () => {
    // try {
    //   const url = `${API_BASE_URL}/Accounts/get_voucher_details_by_voucher_id/${voucherId}`;
    //   const response = await axios.get(url);
    //   console.log('get data from the table', response.data);
    //   //   setVoucherData(response.data);
    //   //   setShowVoucher(true);
    // } catch (err) {
    //   toast.error("Failed to Load Expense Voucher.");
    // }
  };

  const TableData = Array.isArray(data)
    ? data.map((item, index) => ({
        ...item,
        sn: index + 1,
      }))
    : [];

  console.log(TableData);

  const columns = [
    {
      name: "regYear",
      label: "Reg Year",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-center text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "vol",
      label: "Vol",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "sr",
      label: "Sr",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "recptDate",
      label: "recptdate",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">
            {formatDate(value, "dd/MM/yyyy")}
          </div>
        ),
      },
    },
    {
      name: "appName",
      label: "appname",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "appAdd",
      label: "appadd",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "typeRecpt",
      label: "type_recpt",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start text-xs md:text-sm">{value}</div>
        ),
      },
    },
    {
      name: "typeRecpt",
      label: "ACTION",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const rowData = data[tableMeta.rowIndex]; // Get row data
          return (
            <button
              className="capitalize py-1 px-2 rounded-md cursor-pointer"
              onClick={() =>
                handleNavigateUpdatePages(
                  rowData.typeRecpt,
                  rowData.regYear,
                  rowData.vol,
                  rowData.sr
                )
              }
            >
              <img
                src={editmodificationimg}
                alt="Edit Modification"
                className="w-6 h-6"
              />
            </button>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    elevation: 0,
    rowsPerPageOptions: [10, 15, 25, 50],
    responsive: "standard",
    tableBodyHeight: "auto",
    tableBodyMaxHeight: "auto",
    download: false, // Disables the default download (CSV export) button
    print: false, // Disables the default print button
    viewColumns: false, // Disables the default view columns button
    search: true, // Enables the default search button
    customToolbarSelect: () => null, // Hide default toolbar select (if not needed)
  };

  const getMuiTheme = () =>
    createTheme({
      typography: {
        fontFamily: "Poppins",
      },
      palette: {
        background: {
          paper: "#ffffff",
          default: "#ffffff",
        },
        mode: "light",
      },
      components: {
        MuiTableCell: {
          styleOverrides: {
            head: {
              backgroundColor: "#CACACA !important",
              color: "#000000 !important",
              padding: "2px 1px",
              borderBottom: "2px solid #ECECEC",
              borderRight: "0px solid #ddd",
              fontSize: "10px",
              textAlign: "start",
              "@media (min-width: 768px)": {
                // Medium breakpoint (md)
                fontSize: "inherit",
              },
              "& .MuiTableSortLabel-root": {
                color: "#000000 !important",
                "&.MuiTableSortLabel-active": {
                  color: "#000000 !important",
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#000000 !important",
              },
              "&:hover": {
                color: "#ffffff !important",
                backgroundColor: "#929292 !important",
              },
            },
            body: {
              padding: "7px 15px",
              color: "#000000",
              borderBottom: "1px solid #ECECEC",
              borderRight: "0px solid #000000",
            },
            footer: {
              padding: "7px 15px",
              borderBottom: "0px solid #ECECEC",
            },
          },
        },
      },
    });

  return (
    <>
      {/* {showVoucher && <VoucherPopup data={voucherData} attachmentData={attachmentData} openPopup={true} />}       */}
      <div className="py-2 flex">
        <Box width="100%">
          <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              data={TableData}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Box>
      </div>
    </>
  );
};

export default ModifyReceiptTable;
